import { BaseContainerModel } from "../base-container.model";

import {
  bl_pgw_monthly_merchant_txn_summary_report_line_RowClass,
  bl_pgw_monthly_merchant_txn_summary_report_line_RowInterface,
} from "../../dbschema";

export class MerchantTxnReportContainerModel extends BaseContainerModel {
  bl_pgw_monthly_merchant_txn_summary_report_line: bl_pgw_monthly_merchant_txn_summary_report_line_RowInterface =
    new bl_pgw_monthly_merchant_txn_summary_report_line_RowClass();
}
